import './App.css';
import React, {useState} from "react";

import 'react-toastify/dist/ReactToastify.css';
import Popover from '@mui/material/Popover';
import Typography from "@mui/material/Typography";
import moment from "moment";
import { codeList } from "./utils/tableDisplay";
import 'moment/locale/tr';
 let timer=0;
export default function TaskListPopup(props) {

   const [open, setOpen] = useState(false);
   const [anchorEl, setAnchorEl] = useState(null);
   const [teklif_no, setTeklif_no] = useState(null);


   function  popupOpen(event) {
       setAnchorEl(event.currentTarget);
       setTeklif_no(event.target.id)
       setOpen(true)
       //console.log(props.itemC)
   }

   const  popupClose = (event) => {
       setAnchorEl(null);
       setOpen(false);
       setTeklif_no(null)
   };

   function mouseLeave(){
       clearTimeout(timer);

       setOpen(false);
   }




    function Makineler() {
        let uyfler = codeList(props.itemC?.uyfler);
        let makineler = codeList(props.itemC?.makineler);

        const listItems = uyfler.map((uyf,i) =>
            <li><strong>UYF:</strong>{uyf} <strong>Makine:</strong>{makineler[i]} </li>
        );
        return (
            <ul>{listItems}</ul>
        );
    }

    function IsimListesi(item) {
        const birlesikIsimler = codeList(item).join(', ');

        return <div>{birlesikIsimler}</div>;
    }

   return (
           <div  style={{   maxWidth:'1200px' }}
           >
                <Popover
                    id="mouse-over-popover"
                    style={{ pointerEvents: 'none'  }}
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left"
                    }}
                  >
                  <Typography>{props.itemC?.firma?.substring(0, props.itemC?.firma.indexOf(' '))} / {props.itemC?.lokasyon} / {props.itemC?.is_emri_no}</Typography>
                    <Typography><strong>Adres:</strong>{props.itemC.lokasyon_adresi}</Typography>

                    <Typography><strong>Yetkili:</strong> {props.itemC.ilgili_kisi} | {props.itemC.ilgili_kisi_telefon} | {props.itemC.ilgili_kisi_eposta}</Typography>
                    <Typography><strong>M. Temsilcisi:</strong> {props.itemC.temsilci} </Typography>
                    <Typography><strong>Makineler:</strong></Typography>
                    <Makineler/>
                    <Typography><strong>Servis Sebebi:</strong> {props.itemC.sebep}</Typography>
                    <Typography><strong>Kişiler:</strong> {IsimListesi(props.itemC.personeller)}</Typography>
                    <Typography><strong>Baslanıç:</strong> {moment(props.itemC.is_emri_baslangic_tarihi).format('DD/MM/yyyy')} / {moment(props.itemC.start).format('HH:mm:ss')} </Typography>
                    <Typography><strong>Bitiş:</strong> {moment(props.itemC.is_emri_bitis_tarihi).format('DD/MM/yyyy')} / {moment(props.itemC.end).format('HH:mm:ss')}</Typography>
                </Popover>
               <div style={{ padding:0, width:'100%',height:'100%' }} aria-owns={open ? 'mouse-over-popover' : undefined}
                     aria-haspopup="true"
                     onMouseEnter={popupOpen}
                     onMouseLeave={mouseLeave}>
                   &nbsp;&nbsp;&nbsp;&nbsp;
               </div>
           </div>
        );
}
